<toaster-container></toaster-container>
<h2 class="title">
  <span *ngIf="isFirst">Welcome!</span>
  <span *ngIf="!isFirst">Reset Password</span>
</h2>
<span *ngIf="isFirst" class="d-block">Please set a password for {{ email }}</span>
<form [formGroup]="passwordForm" autocomplete="off" class="mt-4">
  <mat-form-field>
    <input matInput type="password"
           [placeholder]="isFirst ? 'Password': 'New Password'"
           formControlName="password1" required />
    <ng-container *ngIf="password1.invalid && (password1.dirty || password1.touched)">
      <mat-error>
        A new password is a required
      </mat-error>
    </ng-container>
  </mat-form-field>
  <mat-form-field>
    <input matInput type="password" placeholder="Confirm Password" formControlName="password2" required />
    <ng-container *ngIf="password2.dirty || password2.touched">
      <mat-error *ngIf="password1.value !== password2.value">
        Passwords don't match
      </mat-error>
      <mat-error *ngIf="password2.invalid && password2.errors.required">
        A confirm password must be set
      </mat-error>
    </ng-container>
  </mat-form-field>
  <br />
  <button
    mat-raised-button
    [disabled]="submitted || passwordForm.invalid || password1.value != password2.value"
    color="primary"
    [class.btn-pulse]="submitted"
    (click)="updatePassword()"
  >
    {{ isFirst ? 'Set Password' : 'Update password' }}
  </button>
</form>

<br />

<p>Already have an account? <a [routerLink]="['/auth', 'login']" class="auth-link">Log In</a></p>

